export const APP_VERSION = import.meta.env.VITE_APP_VERSION;

export const ACCESS_TOKEN = "live-access-token";

export const KEEP_ALIVE_TOKEN = "live-keep-alive-token";

export const LOCAL_STORAGE_LANG = "lang";

export const COOKIE_SID = "SID";

export const COOKIE_MARK = "MARK";

export const COOKIE_CLOSE_PUNCH_IN = "CLOSE_PUNCH_IN";

export const COOKIE_SHOW_BROWSER_DETECT = "SHOW_BROWSER_DETECT";

export const STREAM_STORE = "STREAM_STORE";

export const NOTIFICATION_STORE = "NOTIFICATION_STORE";

export const IMAGE_SIZES = "100vw, (max-width: 768px) 768px, (max-width: 1200px) 1200px, (max-width: 1920px) 1920px";

export const IMAGE_TYPES = ["image/png", "image/jpeg", "image/jpg"];

export const IS_DEV = process.env.NODE_ENV === "development";

export const IS_HISTORY_INIT = "IS_HISTORY_INIT";

export const TRACE_LOG_QUEUE_STORE = "TRACE_LOG_QUEUE_STORE";

export enum Platform {
  mobile = 1,
  desktop = 2,
}

export enum Channel {
  WebDesktop = 1,
  WebMobile = 2,
  PwaDesktop = 3,
  PwaMobile = 4,
  JobManagement = 5,
  IOSApp = 6,
  AndroidApp = 7,
}

export const THEME: Record<string, Theme> = {
  PURPLE: "purple",
  DEEP_PURPLE: "deep-purple",
  RED: "red",
} as const;
